/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ExamDetailsItemAliases {
  AVATAR = 'avatar',
  BUTTON_VIEW_PACS = 'button-view-pacs',
  CARD_CONTAINER_BODY_EXAM = 'card-container-body-exam',
  CARD_CONTAINER_EXAM = 'card-container-exam',
  CARD_CONTAINER_ZONE_EXAM = 'card-container-zone-exam',
  CARD_CONTAINER_ZONE_EXAM_AVATAR = 'card-container-zone-exam-avatar',
  CARD_CONTAINER_ZONE_EXAM_CONTENT = 'card-container-zone-exam-content',
  CARD_CONTAINER_ZONE_EXAM_DATE = 'card-container-zone-exam-date',
  CARD_CONTAINER_ZONE_EXAM_STATUS = 'card-container-zone-exam-status',
  CARD_CONTAINER_ZONE_VIEW = 'card-container-zone-view',
  FIELD_EXAM = 'field-exam',
  FIELD_EXAM_DATE = 'field-exam-date',
  FIELD_EXAM_DETAIL = 'field-exam-detail',
  FIELD_EXAM_STATUS = 'field-exam-status',
  FIELD_EXAM_STATUS_IMAGE = 'field-exam-status-image',
  IMAGE_EXAM_STATUS = 'image-exam-status',
  LAYOUT_EXAM_DETAILS_ITEM = 'layout-exam-details-item',
  PANEL_EXAM_DETAILS_ITEM = 'panel-exam-details-item',
  TEXT_EXAM = 'text-exam',
  TEXT_EXAM_DATE = 'text-exam-date',
  TEXT_EXAM_DETAIL = 'text-exam-detail',
  TEXT_EXAM_STATUS = 'text-exam-status',
}
export { ExamDetailsItemAliases };
